import React, { memo, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@Sage/hoi-poi-ui';
import HtmlPreviewFrame from 'containers/components/HtmlPreviewFrame';
import { getLiteral } from 'utils/getLiteral';

import designLottie from './icons/addons_green-on-solid-black_animated.json';
import DesignOption from './DesignOption';
import htmlLottie from './icons/link_green-on-solid-black_animated.json';
// import templatesLottie from './icons/heart_green-on-solid-black_animated.json';

import './styles.scss';

const DESIGN_OPTIONS = [
    {
        id: 'create_new',
        titleLiteral: 'label_marketing_campaigns_design_email_builder',
        descriptionLiteral: 'label_marketing_campaigns_design_email_builder_desc',
        animation: designLottie,
    },
    // {
    //     id: 'your_templates',
    //     titleLiteral: 'label_email_templates',
    //     descriptionLiteral: 'label_marketing_campaigns_edit_previous_template_desc',
    //     animation: templatesLottie,
    // },
    {
        id: 'html_editor',
        titleLiteral: 'label_marketing_campaigns_design_html_editor',
        descriptionLiteral: 'label_marketing_campaigns_design_html_editor_desc',
        animation: htmlLottie,
    },
];

const DesignForm = memo(({ html = '', onSelectOption }) => {
    const theme = useTheme();
    const handleSelectOption = useCallback(
        (option) => {
            onSelectOption?.(option);
        },
        [onSelectOption],
    );

    const hasBody = useMemo(() => Boolean(html?.trim?.()), [html]);

    const previewTitle = getLiteral('label_marketing_campaigns_design_html_editor');

    if (hasBody) {
        return (
            <div className="marketing-campaigns__design-form">
                <div className="marketing-campaigns__design-preview">
                    <div className="marketing-campaigns__design-preview-surface">
                        <HtmlPreviewFrame
                            className="marketing-campaigns__design-preview-iframe"
                            html={html}
                            title={previewTitle}
                            scale={0.5}
                        />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="marketing-campaigns__design-form">
            <div className="marketing-campaigns__design-form-options">
                {DESIGN_OPTIONS.map((option) => (
                    <DesignOption
                        key={option.id}
                        title={getLiteral(option.titleLiteral)}
                        description={getLiteral(option.descriptionLiteral)}
                        animation={option.animation}
                        textColor={theme.colors.textLight.secondary}
                        onClick={() => handleSelectOption(option)}
                    />
                ))}
            </div>
        </div>
    );
});

DesignForm.displayName = 'DesignForm';

DesignForm.propTypes = {
    html: PropTypes.string,
    onSelectOption: PropTypes.func,
};

export default DesignForm;
